<template>
  <div class="upload_list_box" ref="fileListRef">
    <div class="upload_title">
      <div @click="changeBoxStatus">
        <span>{{ $t("common.file.transfer.list") }}</span>
        <div style="display: inline-block;margin-left: 4px">
          <el-icon v-if="isOpen">
            <ArrowDown/>
          </el-icon>
          <el-icon v-else>
            <ArrowUp/>
          </el-icon>
        </div>
      </div>
      <el-icon style="font-size: 16px;height: 16px;width: 16px;line-height: 45px" @click="removeList">
        <CircleClose/>
      </el-icon>
    </div>
    <div class="upload_content">
      <div v-for="(item, index) in fileList" :key="item.uid || item.name || index">
        <div
          :class="[item.isMouseEnter ? 'hover_bg' : 'no_bg', 'item_box']"
          @mouseenter="handleMouseEnter(item)"
          @mouseleave="handleMouseLeave(item)"
        >
          <div>
            <el-icon v-if="item.percentage===100" color="rgba(0,0,0,.45)" size="14">
              <Link/>
            </el-icon>
            <el-icon v-else class="is-loading" color="rgba(0,0,0,.45)" size="14">
              <Loading/>
            </el-icon>
            <span class="file_name">{{ item?.name || item?.nameSp }}</span>
          </div>
          <div>
            <el-icon class="icon_del" v-if="item.isMouseEnter" @click="deleteTarget(item)">
              <Delete/>
            </el-icon>
          </div>
        </div>
        <el-progress v-if="item.percentage!==100" :percentage="item.percentage"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";

const props = defineProps({
  fileList: {
    type: Array,
    default: () => []
  },
  showFileList: {
    type: Boolean,
    default: false,
  }
})
const emit = defineEmits(['removeList'])

const fileListRef = ref(null)

const setBoxExpanded = (expanded) => {
  if (!fileListRef.value) return

  fileListRef.value.style.height = expanded ? "auto" : "45px"
  fileListRef.value.style.overflow = expanded ? "auto" : "hidden"
  fileListRef.value.style.transition = "all .3s"
}

const switchBoxStateClass = (classNameToAdd, classNameToRemove) => {
  if (!fileListRef.value) return

  fileListRef.value.classList.remove(classNameToRemove)
  fileListRef.value.classList.add(classNameToAdd)
}

// 标识展开还是关闭
const isOpen = ref(true);
const changeBoxStatus = () => {
  if (isOpen.value) {
    setBoxExpanded(false)
  } else {
    setBoxExpanded(true)
  }
  isOpen.value = !isOpen.value
}


const handleMouseEnter = (item) => {
  item.isMouseEnter = true
}
const handleMouseLeave = (item) => {
  item.isMouseEnter = false
}

const deleteTarget = (item) => {
  const targetIndex = props.fileList.findIndex((it) => it.uid === item.uid);
  if (targetIndex !== -1) {
    props.fileList.splice(targetIndex, 1)
  }
}

const removeList = () => {
  switchBoxStateClass("leave_list", "enter_list")
  emit('removeList')
}

const enterList = () => {
  switchBoxStateClass("enter_list", "leave_list")
}

defineExpose({
  enterList,
  removeList,
})

</script>

<style lang="less" scoped>
.upload_list_box {
  box-sizing: border-box;
  box-shadow: 0 0 1px 1px rgba(28, 28, 32, .05), 0 8px 24px rgba(28, 28, 32, .12);
  position: fixed;
  bottom: -640px;
  right: 30px;
  width: 373px;
  min-width: 373px;
  //height: auto;
  //max-height: 400px;
  //min-height: 45px;
  background-color: #fff;
  z-index: 999999;
  transition: all .4s ease-in-out;
  border-radius: 8px;
  padding: 10px;
  //overflow: scroll;

  .upload_title {
    padding: 2px 2px 12px;
    cursor: pointer;
    color: rgba(0, 0, 0, .65);
    font-size: 14px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    width: 356px;
    height: 30px;
    line-height: 30px;
    background: white;


  }

  .upload_content {
    margin-top: 40px;
    height: auto;
    max-height: 400px;
    min-height: 45px;
    overflow: scroll;
  }

  .item_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all .3s;
    cursor: pointer;
    padding: 2px 0px;

    & > div > span {
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: rgba(0, 0, 0, .65);
      font-size: 14px;
    }
  }

  .file_name {
    margin-left: 8px;
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.hover_bg {
  background: #e9f6fe;
}

.no_bg {
  background: white;
}

:deep(.el-progress-bar__outer) {
  margin-top: 4px;
  height: 2px !important;
}

:deep(.el-progress__text) {
  display: none;
}

.icon_del {
  color: rgba(0, 0, 0, .65);
  margin-right: 4px;
}

.leave_list {
  box-sizing: border-box;
  box-shadow: 0 0 1px 1px rgba(28, 28, 32, .05), 0 8px 24px rgba(28, 28, 32, .12);
  position: fixed;
  bottom: -640px;
  right: 30px;
  width: 373px;
  min-width: 373px;
  //height: auto;
  //max-height: 400px;
  //min-height: 45px;
  background-color: #fff;
  z-index: 999999;
  transition: all .4s ease-in-out;
  border-radius: 8px;
  padding: 10px;
  //overflow: scroll;
}

.enter_list {
  box-sizing: border-box;
  box-shadow: 0 0 1px 1px rgba(28, 28, 32, .05), 0 8px 24px rgba(28, 28, 32, .12);
  position: fixed;
  bottom: 38px;
  right: 30px;
  width: 373px;
  min-width: 373px;
  //height: auto;
  //max-height: 400px;
  //min-height: 45px;
  background-color: #fff;
  z-index: 999999;
  transition: all .4s ease-in-out;
  border-radius: 8px;
  padding: 10px;
  //overflow: scroll;
}
</style>
